import { getSharedHeaders } from "./headers";

/**
 * This is a simple wrapper around the fetch API that allows us to set shared headers.
 */
interface FetchOptions extends Omit<RequestInit, "headers"> {
  headers?: Record<string, string>;
}

export function enhancedFetch(
  url: string | URL,
  { method, headers, body, ...options }: FetchOptions,
) {
  return fetch(url, {
    ...options,
    method,
    headers: {
      ...getSharedHeaders(),
      ...headers,
    },
    body,
  });
}
